import React, { useState } from 'react';
import { Users, ChevronDown } from 'lucide-react';
import { Button } from './Button';
import { cn } from '../utils/cn';
import { ShareButtons } from './ShareButtons';

type CommunitySectionProps = {
  open: boolean;
  toggle: (key: string) => void;
  sectionKey: string;
};

export default function CommunitySection({ open, toggle, sectionKey }: CommunitySectionProps) {
  const [activeTab, setActiveTab] = useState<'connect' | 'share'>('connect');

  return (
    <div className="border rounded-xl overflow-hidden bg-white shadow-lg">
      <button
        onClick={() => toggle(sectionKey)}
        className="w-full flex justify-between items-center px-4 py-6 text-left hover:bg-blue-50"
      >
        <div className="flex items-center gap-2 text-[#004060] font-semibold text-xl">
          <Users className="w-6 h-6 text-[#236caf]" />
          Community
        </div>
        <ChevronDown className={cn('w-5 h-5 text-[#236caf] transition-transform duration-200', open && 'rotate-180')} />
      </button>
      
      {open && (
        <div className="p-4 sm:p-6">
          <div className="flex border-b mb-4">
            <button
              onClick={() => setActiveTab('connect')}
              className={cn(
                "px-4 py-2 font-medium text-sm transition-colors",
                activeTab === 'connect' 
                  ? "text-[#236caf] border-b-2 border-[#236caf] -mb-px" 
                  : "text-gray-500 hover:text-gray-700"
              )}
            >
              Connect
            </button>
            <button
              onClick={() => setActiveTab('share')}
              className={cn(
                "px-4 py-2 font-medium text-sm transition-colors",
                activeTab === 'share' 
                  ? "text-[#236caf] border-b-2 border-[#236caf] -mb-px" 
                  : "text-gray-500 hover:text-gray-700"
              )}
            >
              Share
            </button>
          </div>

          {activeTab === 'connect' ? (
            <div className="space-y-4">
              <p className="text-gray-600">
                Join our community to connect with others on their journey and share your progress.
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <Button
                  variant="outline"
                  onClick={() => window.open('https://team.joeychandler.net/invitation?code=A9568G#email', '_blank')}
                  className="w-full"
                >
                  Join Community
                </Button>
                <Button
                  variant="outline"
                  onClick={() => window.open('https://link.elite360.io/widget/booking/tjH770LiUt0mSG35UKRl', '_blank')}
                  className="w-full"
                >
                  Schedule Call
                </Button>
              </div>
            </div>
          ) : (
            <ShareButtons />
          )}
        </div>
      )}
    </div>
  );
}